<style lang="scss">
@import "../../../common/styles/var.scss";

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;

  .banner {
    background-image: url("../assets/bg_login_2.png");
    background-size: 100% 100%;
  }

  .ms-login {
    position: absolute;
    right: 160px;
    width: 310px;
    background-color: white;
    padding: 30px;
  }

  .logo {
    position: absolute;
    top: 20px;
    left: 30px;
  }

  .navs {
    position: absolute;
    right: 30px;
    top: 30px;

    &:after {
      display: block;
      content: "";
      clear: both;
    }

    li {
      position: relative;
      float: left;

      div {
        position: absolute;
        left: 0;
        width: 150px;
        height: 150px;
        background-color: white;
        padding: 5px;
      }
    }

    li + li {
      margin-left: 30px
    }

    a {
      font-size: 16px;
      color: white;
    }


  }

  .footer {
    width: 1080px;
    margin: 0 auto;

    ul {
      padding-top: 30px;
      justify-content: space-around;
    }

    li {
      padding: 10px 0;
      width: 150px;
      height: 100px;
      position: relative;

      .qr {
        position: absolute;
        width: 150px;
        height: 150px;
        background-color: white;
        left: 0;
        bottom: 110px;
      }

      .arrow {
        width: 150px;
        height: 10px;
        position: absolute;
        left: 0;
        bottom: 100px;
      }


      &:hover {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 8px 0px rgba(238, 238, 238, 1);
        border-radius: 4px;
      }
    }

    .thumb {
      height: 45px;
    }

    p {
      font-size: 14px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
    }

    p + p {
      margin-top: 10px;
    }
  }

  .el-input-group__append {
    width: 111px;
    text-align: center;
  }

  .captcha-btn {
    color: $mainColor;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
<template>
  <div class="fullpage">
    <div class="login-wrap" style="overflow-y: hidden;">
      <div class="banner" :style="bannerStyle"></div>
      <div class="footer" style="height: 240px">
        <ul class="flex">
          <li v-for="(item,index) in clients" :key="index" class="flex column aic pointer"
              @mouseenter="item.showQR=true" @mouseleave="item.showQR=false" @click="handler(item)">
            <div class="thumb flex aic jcc"><img :src="item.icon" alt=""></div>
            <h3 class="mt10 color_333 fs16">{{ item.name }}</h3>
            <div class="arrow flex aic jcc" v-if="item.showQR&&item.qr">
              <img src="../assets/arrow.fw.png" height="10" alt="">
            </div>
            <div class="qr" v-if="item.showQR&&item.qr" style="padding: 5px">
              <img :src="item.qr" alt="" style="width: 140px">
            </div>
          </li>
        </ul>
        <p class="mt30">浙江日报报业集团</p>
        <p class="flex aic jcc pb30">©浙江智慧网络医院管理有限公司版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;工信部备案号&nbsp;&nbsp;<a
            href="http://beian.miit.gov.cn">浙ICP备17007984号-1</a>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/icon_police_2763990@2x.png" alt="">&nbsp;&nbsp;浙公安网备
          33010302003380</p>
      </div>
      <img src="../assets/LOGO.png" alt="" class="logo">
      <ul class="navs">
        <li v-for="(item,index) in navs" :key="index">
          <a v-if="item.link" :href="item.link">{{ item.name }}</a>
          <template v-else>
            <a class="pointer" @click="handler2(item)">{{ item.name }}</a>
            <div v-if="item.showQR" class="qr" style="top: 30px; z-index: 100">
              <img :src="item.qr" alt="" width="140">
            </div>
          </template>
        </li>
      </ul>
      <div class="ms-login" :style="style">
        <h3 class="flex aic jcc pb30 fs20">登录急重症患者转诊平台</h3>
        <el-form :model="form" :rules="rules" ref="form" label-width="0px" class="demo-ruleForm">
          <el-form-item prop="userMobile">
            <el-input
                v-model="form.userMobile"
                prefix-icon="el-icon-phone-outline"
                placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="userPassword">
            <el-input
                type="password"
                prefix-icon="el-icon-edit-outline"
                placeholder="请输入密码"
                v-model="form.userPassword"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="form.userType">
              <el-radio label="AID_ADM">临床管理员</el-radio>
              <el-radio label="AID_E_ADM">审核管理员</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--<el-form-item prop="captcha">
              <el-input
                  prefix-icon="el-icon-edit-outline"
                  placeholder="请输入验证码" v-model="form.captcha">
                  <template slot="append">
                      <account-send-captcha :form="form"></account-send-captcha>
                  </template>
              </el-input>
          </el-form-item>-->
          <div class="login-btn">
            <el-button
                :loading="appShowLoading"
                class="width100"
                type="primary"
                @click="sub"
            >登录
            </el-button>
          </div>
        </el-form>
      </div>
      <!--<div class="footer">Copyright © 2007-2016 | 杭州特扬网络科技有限公司 版权所有</div>-->
    </div>
  </div>
</template>

<script>
import {staffService} from "../../staff/service/staff";
import {tokenCache} from "../../../common/lib/cache/Token";
import {loginInfoCache} from "../../../common/lib/cache/LoginInfo";
import {EVENT_LOGIN_SUCCESS} from "../events";
import {USER_TYPE} from "@/common/lib/config";

export default {
  name: "login",
  components: {},
  data() {
    return {
      form: {
        userType: 'AID_ADM'
      },
      style: {},
      bannerStyle: {},
      navs: [
        {
          name: "浙二互联网医院官网",
          link: "https://app2.z2ehospital.com"
        },
        {
          name: "浙大二院官网",
          link: "https://www.z2hospital.com/"
        },
        {
          name: "浙二互联网医院官微",
          showQR: false,
          qr: require("../assets/QR_wechat.png")
        }
      ],
      clients: [
        {
          name: "浙二好医生",
          icon: require("../assets/pat.png"),
          qr: require("../assets/QR_pat.png"),
          showQR: false
        },
        {
          name: "浙二好医生医护版",
          icon: require("../assets/doc.png"),
          qr: require("../assets/QR_doc.png"),
          showQR: false
        },
        {name: "急救Pad端", icon: require("../assets/pad.png"), download: true, key: 'apk'},
        {name: "视频客户端", icon: require("../assets/exe.png"), download: true, key: 'hushi_exe_download'}
      ],
      rules: {
        userMobile: [
          {required: true, message: "请输入手机号", trigger: "blur"}
        ],
        userPassword: [
          {required: true, message: "请输入密码", trigger: "blur"}
        ]
        //captcha: [{required: true, message: "请输入验证码", trigger: "blur"}]
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const H = window.innerHeight;
      this.$set(this.bannerStyle, "height", `${H - 240}px`);
      this.$set(this.style, "top", `${(H - 240) / 2 - 140}px`);
    },
    handler(data) {
      if (data.download) location.href = this.env[data.key];
    },
    handler2(data) {
      if (data.qr) data.showQR = !data.showQR;
    },
    sub() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let form = {...this.form};
          // eslint-disable-next-line no-undef
          form.userPassword = sha512(hex_md5(form.userPassword) + form.userPassword)
          const {token, obj} = await staffService.login(form);
          tokenCache.set(token);
          loginInfoCache.set(obj);
          const {staffType} = obj;
          bus.$emit(EVENT_LOGIN_SUCCESS, 1);
          this.$router.push((USER_TYPE[staffType] && USER_TYPE[staffType].defaultIndex) || '/');
        }
      })
    }
  },
}
</script>

